import React from "react";
import { ChangeEvent,useEffect,useState ,useCallback, useRef} from "react";
import { Link,useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import MbpAthnUi from "Utils/MbpAthn";
// import EmlAthnModalUi from "Utils/EmlAthnModalUi";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import { isMobile } from "react-device-detect";
import MgpStore from "Stores/Store";
import"Assets/css/MembFind.css";
import MbpAthnRsltVrfRqstApi from "Apis/MbpAthnRsltVrfRqstApi";
import MbpAthnTknCrtRqstApi from 'Apis/MbpAthnTknCrtRqstApi';
import useRecaptcha from 'Utils/useRecaptcha';
import ApiError from "Utils/ApiError";
import { Api } from "@mui/icons-material";
import ApiResultModal from "Components/ApiResultModal";


declare global {
    interface Window { kmcRespFunc: any; }
}
const AppMembPasswdChngUi = () => {
    const navigate = useNavigate();
    const {isLoading,error,data: langData}:any = UseLangLstQuery();;
    var popupX = Math.round(window.screenX + (window.outerWidth/2) - (500/2));
    var popupY = Math.round(window.screenY + (window.outerHeight/2) - (800/2));
    const { getToken } = useRecaptcha();
    const [emlAthnPrpsCd] =useState("PWD_RSET");
    const [loginIdRsltVal,setLoginIdRsltVal] = useState("");
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    // const [showEmlModal, setShowEmlModal] = useState(false);

    const openResultModal = (message: string) => {
        setResultModalMessage(message);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
    };
    const loginIdRef = useRef("");
    const EmlAthnPopFunc = (e:any)=>{
        window.open(e,"_blank","width=550,height=800 left="+popupX+"top="+popupY);
    }
    const LoginIdInputValHandler = (event:ChangeEvent<HTMLInputElement>) => {
        const nextLoginId = event.currentTarget.value;
        setLoginIdRsltVal(nextLoginId);
        loginIdRef.current = nextLoginId;
    }
    const [mbpAthnTkn,setMbpAthnTkn] = useState("");
    const reqKMCISForm:any = document.getElementById('reqKMCISForm');
    const reqTr_cert:any = document.getElementById('tr_cert');
    var KMCIS_window;
    useEffect(()=>{
        function kmcRespFunc (kmcApiTknrslt:string,kmcApiCertNumrslt:string){
            MbpAthnRsltVrfRqstApi(kmcApiTknrslt,kmcApiCertNumrslt)
            .then((resp) => {
                switch(resp.apiHdr.code){
                    case "ATHN0000":
                        navigate("/Connect/MembFindPw/FindPwInput",{state:{idntMthdCd:"MBP",membId:resp.apiBody.loginId}});
                        return;
                    case "ATHN2312" :
                        openResultModal(langData&&langData.MEMB_FIND_PASSWD_EML_ATHN_NO_SEND_ERROR_00);
                        break;
                    default:
                        ApiError(langData,resp.apiHdr.code);
                    break;
                       
                }
            })
        }
        window.kmcRespFunc = kmcRespFunc;
        function emlAthnRespFunc(athnPrpsCd:string,emlAddr:string) {
            if(athnPrpsCd == emlAthnPrpsCd){
                navigate("/Connect/MembFindPw/FindPwInput",{state:{idntMthdCd:"EML",membId:loginIdRef.current}})
            }else {

            }
        }
        window.emlAthnRespFunc = emlAthnRespFunc;
    },[])
    const  MbpAthnTknCrtRqstFunc = (e:any) => {
        e.preventDefault();
        let athnPrpsCd =emlAthnPrpsCd;
        const currentLoginId = loginIdRef.current.trim();
        let loginId = currentLoginId;
        if(currentLoginId.length < 1) {
            openResultModal(langData&&langData.MEMB_JOIN_ID_INPUT_DESC_00);
            return ;
        }
        switch(athnPrpsCd){
            case"PWD_RSET":
            MbpAthnTknCrtRqstApi(athnPrpsCd,loginId).then((resp) => {
                switch(resp.apiHdr.code){
                    case "ATHN2000":
                        openResultModal("회원정보가 존재하지않습니다.");
                        throw new Error("ATHN2000"); // 에러를 throw해서 다음 then 실행 방지
                    case "ATHN0000":
                        reqTr_cert.value =resp.apiBody.kmcTkn;
                        setMbpAthnTkn(resp.apiBody.kmcTkn);
                        return resp; // 성공 시에만 다음 then으로 진행
                    default:
                        throw new Error("Unknown error code");
                }
            }).then((resp)=>{
                openKMCISWindow();
            }).catch((error) => {
               
               
            });
            break;
            default:
            e.preventDefault();
            MbpAthnTknCrtRqstApi(athnPrpsCd,null).then((resp) => {
                setMbpAthnTkn(resp.apiBody.kmcTkn);
            });
            break;
        }
        // reCAPTCHA token handled at action time by shared hook
    }
    const EmlAthnFunc = () => {
        const currentLoginId = loginIdRef.current.trim();
        if (currentLoginId.length < 1) {
            openResultModal(langData && langData.MEMB_JOIN_ID_INPUT_DESC_00);
            return false;
        }
        navigate("/Connect/MembFindPw/FindPwInput", { state: { idntMthdCd: "EML", membId: currentLoginId } });
    }
     function openKMCISWindow (){
        if(isMobile == true) {
            reqKMCISForm.target = '';
        }else {
            KMCIS_window = window.open('', 'KMCISWindow', 'width=425, height=550, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250' );
            
            if(KMCIS_window == null){
                openResultModal(" ※ 윈도우 XP SP2 또는 인터넷 익스플로러 7 사용자일 경우에는 \n    화면 상단에 있는 팝업 차단 알림줄을 클릭하여 팝업을 허용해 주시기 바랍니다. \n\n※ MSN,야후,구글 팝업 차단 툴바가 설치된 경우 팝업허용을 해주시기 바랍니다.");
            }
            reqKMCISForm.target = 'KMCISWindow';
        };
        reqKMCISForm.action = 'https://www.kmcert.com/kmcis/web/kmcisReq.jsp';
        reqKMCISForm.submit();
    }
    return(
        <div className="loginInputWrap">
            <ApiResultModal
                open={resultModalOpen}
                message={resultModalMessage}
                onClose={closeResultModal}
                confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
                app={"app"}
            />
           <Helmet>
                <title>BE@RBRICK CONNECT - Find Password</title>
            </Helmet>
            <div className="membJoinForm">
                <div className="membFindPwTitl membFindTitl">
                    
                    <h1>{langData&&langData.MEMB_FIND_PASSWD_MAIN_TITL_00}</h1>
                    <p>
                        {langData&&langData.MEMB_FIND_PASSWD_MAIN_DESC_00}
                    </p>
                    <input type="text"  placeholder={langData&&langData.MEMB_JOIN_ID_INPUT_DESC_00} onChange={LoginIdInputValHandler}/>
                    {/* 아이디를 입력해주세요 */}
                </div>
                <div className="athnWrap">
                    <ul>
                        <li className="athnLi">
                            <p className="athnTitl">{langData&&langData.MEMB_FIND_PASSWD_MBP_LBL_00}</p>
                            {/* 휴대폰 인증 */}
                            <div className="athnImgWrap">
                                <img src={process.env.PUBLIC_URL + "/images/Connect/Login/appMbpIcon.png"} alt="" />
                            </div>
                            <form id="reqKMCISForm" method="post" name="reqKMCISForm" action="#">
                        
                                <input type="hidden" id="tr_cert" className="tr_cert" value={mbpAthnTkn} name="tr_cert"/>
                                <input type="hidden" className="tr_url" value={process.env.REACT_APP_KMC_REDIRECT_URL}  name="tr_url"/>
                                <input type="hidden" value={"V2"}      name="tr_ver"/>
                                <button type="submit"  onClick={MbpAthnTknCrtRqstFunc} className="loginBtn">
                                    <p>{langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00}</p>
                                </button>
                            </form>
                            {/* <MbpAthnUi  athnPrpsCd={'PWD_RSET'}AthnTxt={langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00}loginId={loginIdRsltVal}/> */}
                        </li>
                        <li className="athnLi">
                            <p className="athnTitl">{langData&&langData.MEMB_FIND_PASSWD_EML_LBL_00}</p>
                            {/* 이메일 인증 */}
                            <div className="athnImgWrap">
                                <img src={process.env.PUBLIC_URL + "/images/Connect/Login/appEmlIcon.png"} alt="" />
                            </div>
                            <button onClick={EmlAthnFunc} className="loginBtn">
                                <p>{langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00}</p>
                                {/* 인증하기 */}
                            </button>
                            {/* 이메일 인증 모달 제거됨 */}
                        </li>
                    </ul>
                    <p className="findPwNoti">{langData&&langData.FIND_PASSWD_SSO_NOTI_LBL_00}</p>
                </div>
            </div>
            {/* reCAPTCHA provided at app root; tokens requested via useRecaptcha hook */}
        </div>
    )
}

export default AppMembPasswdChngUi;